var _defs, _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    height: 21,
    width: 21,
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, "airport.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title92"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    id: "rect94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    rx: 10.5,
    ry: 10.5,
    fill: "#ffffff",
    id: "rect96"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "m 13.999224,8.5999971 8e-4,-0.4999971 -0.4928,0.00239 c -0.4589,0.00222 -0.5846,-0.00653 -0.4643,0.036804 0.3259,0.117338 0.7313,0.426328 0.8734,0.765162 l 0.082,0.195639 z",
    id: "path688-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "M 4.499179,8.5999971 4.5,8.1 4.007246,8.10239 C 3.548343,8.10461 3.42259,8.09586 3.542949,8.139194 3.86881,8.256532 4.274155,8.565522 4.41629,8.904356 l 0.08207,0.195639 z",
    id: "path688-3-6-7"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m -1.0654834,10.084141 v 1.6818 l -6.4999999,-1 -0.3182,4.7727 2.8182,1.7273 v 1 l -3.5,-0.6818 -3.4999997,0.6818 v -1 l 2.8181997,-1.7273 -0.3182,-4.7727 -6.4999997,1 v -1.6818 l 6.4999997,-2.3182002 v -3 c 0,0 0,-1.5 1,-1.5 1,0 1,1.5 1,1.5 v 2.8182 z",
    id: "path98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 0.86594,
      imageRendering: "auto"
    },
    id: "rect470",
    width: 2.5,
    height: 9,
    x: 4.5,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 0.86594
    },
    id: "rect472",
    width: 2.5,
    height: 9,
    x: 14,
    y: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(-0.67733121,0.21776896)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.03077
    },
    id: "rect611",
    width: 17,
    height: 1.2,
    x: 2.6773312,
    y: 6.6822309
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 1.19322
    },
    id: "path617",
    cx: -14.959525,
    cy: 4.305562,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.0357387
    },
    d: "M 7.0008943,8.5999974 7,8.1 7.5369275,8.10239 C 8.0369726,8.10461 8.0641815,8.10798 7.9330328,8.151314 7.5779595,8.2686569 7.2460909,8.5655271 7.0912131,8.9043611 L 7.0017883,9.1 Z",
    id: "path688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 0.034237
    },
    d: "M 16.500821,8.5999974 16.5,8.1 16.992754,8.10239 C 17.451657,8.10461 17.57741,8.09586 17.457051,8.139194 17.13119,8.2565323 16.725845,8.5655219 16.58371,8.9043563 l -0.08207,0.1956392 z",
    id: "path688-3"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.632b061e672e627178befb440852a4c6.svg";
export { ForwardRef as ReactComponent };